module.exports = __webpack_public_path__ + "static/img/IT.f07d1769.png";